import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import type { updatePartnerOffersAgreementInput } from '#src/__generated__/globalTypes.ts';
import { useMutation } from '#src/hooks/graphql/useMutation.ts';

import type {
  UpdatePartnerOffersAgreementMutation,
  UpdatePartnerOffersAgreementMutationVariables,
} from './__generated__/index.graphql.ts';

const UPDATE_PARTNER_OFFERS_AGREEMENT = gql`
  mutation UpdatePartnerOffersAgreementMutation(
    $input: updatePartnerOffersAgreementInput!
  ) {
    updatePartnerOffersAgreement(input: $input) {
      errors {
        message
        code
      }
    }
  }
` as TypedDocumentNode<
  UpdatePartnerOffersAgreementMutation,
  UpdatePartnerOffersAgreementMutationVariables
>;

export const useUpdatePartnerOffersAgreement = () => {
  const [mutate] = useMutation(UPDATE_PARTNER_OFFERS_AGREEMENT);

  return async (input: updatePartnerOffersAgreementInput) => {
    return mutate({
      variables: { input },
    });
  };
};
